/*
  Le Studio Aqua — comportements « pages courtes » sur téléphone (< 750 px).
  Sur tablette et ordinateur, rien ne change : tout reste ouvert et visible.

  1. Textes repliables .............. [data-repliable]          (A4, B1, C1, C3, D1)
  2. Blocs ouverts sur ordinateur ... details[data-ouvert-ordinateur] (E1, F1)
  3. Rayons en accordéon ............ [data-rayon-accordeon]    (B3)
  4. Trombinoscope de l'équipe ...... [data-equipe]             (variante 2)
  5. Barre d'achat collée ........... [data-barre-achat]        (E2)
  6. « Voir plus » + filtres ........ #product-grid, [data-filtres] (B5, B4)
*/
(function () {
  const mq = window.matchMedia('(max-width: 749px)');
  const estTelephone = () => mq.matches;

  /* 1. Textes repliables ------------------------------------------------ */
  function majRepliable(bloc) {
    const texte = bloc.querySelector('.repliable__texte');
    const bouton = bloc.querySelector('[data-repliable-bouton]');
    if (!texte || !bouton) return;
    if (!estTelephone()) {
      bouton.hidden = true;
      return;
    }
    if (bloc.classList.contains('is-ouvert')) {
      bouton.hidden = false;
      return;
    }
    // Le texte est coupé par CSS : on n'affiche le bouton que s'il dépasse.
    bouton.hidden = texte.scrollHeight <= texte.clientHeight + 2;
  }

  function initRepliables(racine) {
    racine.querySelectorAll('[data-repliable]').forEach((bloc) => {
      if (!bloc.dataset.pret) {
        bloc.dataset.pret = 'true';
        const bouton = bloc.querySelector('[data-repliable-bouton]');
        if (bouton) {
          bouton.addEventListener('click', () => {
            const ouvert = bloc.classList.toggle('is-ouvert');
            bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
            bouton.textContent = ouvert ? 'Réduire' : 'Lire la suite';
          });
        }
      }
      majRepliable(bloc);
    });
  }

  /* 2. Blocs ouverts sur ordinateur, fermés sur téléphone --------------- */
  function initDetails(racine) {
    racine.querySelectorAll('details[data-ouvert-ordinateur]').forEach((el) => {
      el.open = !estTelephone();
    });
  }

  /* 3. Rayons en accordéon (page Nos produits) -------------------------- */
  function appliquerRayon(rayon, ouvert) {
    rayon.classList.toggle('is-ouvert', ouvert);
    const bouton = rayon.querySelector('[data-rayon-bascule]');
    if (bouton) bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  }

  function initRayons(racine) {
    racine.querySelectorAll('[data-rayon-accordeon]').forEach((rayon) => {
      const bouton = rayon.querySelector('[data-rayon-bascule]');
      if (!rayon.dataset.pret && bouton) {
        rayon.dataset.pret = 'true';
        bouton.addEventListener('click', () => {
          if (!estTelephone()) return;
          appliquerRayon(rayon, !rayon.classList.contains('is-ouvert'));
        });
      }
      // Téléphone : tout est replié au départ ; ailleurs : tout est ouvert.
      appliquerRayon(rayon, !estTelephone());
    });
  }

  /* 4. Trombinoscope de l'équipe ---------------------------------------- */
  function choisirMembre(equipe, index) {
    const onglets = equipe.querySelectorAll('[data-equipe-onglet]');
    const panneaux = equipe.querySelectorAll('[data-equipe-panneau]');
    onglets.forEach((onglet, i) => {
      const actif = i === index;
      onglet.classList.toggle('is-actif', actif);
      onglet.setAttribute('aria-selected', actif ? 'true' : 'false');
      onglet.tabIndex = actif ? 0 : -1;
    });
    panneaux.forEach((panneau, i) => panneau.classList.toggle('is-actif', i === index));
  }

  function initEquipes(racine) {
    racine.querySelectorAll('[data-equipe]').forEach((equipe) => {
      const liste = equipe.querySelector('[data-equipe-onglets]');
      const onglets = [...equipe.querySelectorAll('[data-equipe-onglet]')];
      const panneaux = [...equipe.querySelectorAll('[data-equipe-panneau]')];
      if (!liste || onglets.length === 0) return;

      if (!equipe.dataset.pret) {
        equipe.dataset.pret = 'true';
        onglets.forEach((onglet, i) => {
          onglet.addEventListener('click', () => choisirMembre(equipe, i));
          onglet.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const suivant = (i + (e.key === 'ArrowRight' ? 1 : -1) + onglets.length) % onglets.length;
            choisirMembre(equipe, suivant);
            onglets[suivant].focus();
          });
        });
      }

      if (estTelephone()) {
        equipe.classList.add('is-trombi');
        liste.setAttribute('role', 'tablist');
        liste.setAttribute('aria-label', "L'équipe");
        onglets.forEach((o) => o.setAttribute('role', 'tab'));
        panneaux.forEach((p, i) => {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('aria-labelledby', onglets[i].id);
        });
        const actuel = onglets.findIndex((o) => o.classList.contains('is-actif'));
        choisirMembre(equipe, actuel >= 0 ? actuel : 0);
      } else {
        equipe.classList.remove('is-trombi');
        liste.removeAttribute('role');
        liste.removeAttribute('aria-label');
        onglets.forEach((o) => {
          o.removeAttribute('role');
          o.removeAttribute('aria-selected');
          o.removeAttribute('tabindex');
        });
        panneaux.forEach((p) => {
          p.removeAttribute('role');
          p.removeAttribute('aria-labelledby');
        });
      }
    });
  }

  /* 5. Barre d'achat collée (fiche produit) ----------------------------- */
  function initBarresAchat(racine) {
    racine.querySelectorAll('[data-barre-achat]').forEach((barre) => {
      if (barre.dataset.pret) return;
      barre.dataset.pret = 'true';
      const section = barre.closest('product-info') || document;
      const principal = section.querySelector('.product-form__submit');
      if (!principal || !('IntersectionObserver' in window)) return;
      const obs = new IntersectionObserver(([entree]) => {
        const passe = !entree.isIntersecting && entree.boundingClientRect.top < 0;
        const afficher = estTelephone() && passe;
        barre.hidden = !afficher;
        document.body.classList.toggle('barre-achat-visible', afficher);
      });
      obs.observe(principal);
    });
  }

  /* 6. « Voir plus » (B5) et filtres rapides (B4) sur les grilles ------- */
  function lienSuivant(racine) {
    const lien = racine.querySelector('.pagination__item--prev[href]');
    return lien ? lien.getAttribute('href') : null;
  }

  async function chargerPageSuivante(etat) {
    if (!etat.suivant || etat.enCours) return false;
    etat.enCours = true;
    etat.bouton.setAttribute('aria-busy', 'true');
    try {
      const rep = await fetch(etat.suivant, { credentials: 'same-origin' });
      const doc = new DOMParser().parseFromString(await rep.text(), 'text/html');
      const nouvelle = doc.getElementById('product-grid');
      if (nouvelle) {
        nouvelle.querySelectorAll(':scope > li').forEach((li) => {
          li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          etat.grille.appendChild(li);
        });
      }
      etat.suivant = lienSuivant(doc);
    } catch (e) {
      etat.suivant = null;
      window.location.href = etat.lienSecours;
      return false;
    } finally {
      etat.enCours = false;
      etat.bouton.removeAttribute('aria-busy');
    }
    majBoutonVoirPlus(etat);
    appliquerFiltre(etat);
    return true;
  }

  function majBoutonVoirPlus(etat) {
    const affiches = etat.grille.querySelectorAll(':scope > li').length;
    const restants = Math.max(etat.total - affiches, 0);
    if (!etat.suivant || restants === 0 || etat.filtre) {
      etat.bouton.hidden = true;
      return;
    }
    etat.bouton.hidden = false;
    etat.bouton.textContent = `Voir plus · ${restants} restant${restants > 1 ? 's' : ''}`;
  }

  function appliquerFiltre(etat) {
    const mot = etat.filtre;
    let visibles = 0;
    etat.grille.querySelectorAll(':scope > li').forEach((li) => {
      const titre = (li.querySelector('.card__heading')?.textContent || '').toLowerCase();
      const garder = !mot || titre.includes(mot);
      li.hidden = !garder;
      if (garder) visibles += 1;
    });
    if (etat.annonce) {
      etat.annonce.textContent = mot ? `${visibles} produit${visibles > 1 ? 's' : ''} affiché${visibles > 1 ? 's' : ''}` : '';
    }
  }

  function initGrille() {
    const grille = document.getElementById('product-grid');
    if (!grille || grille.tagName !== 'UL' || grille.dataset.pret) return;
    const conteneur = grille.parentElement;
    const pagination = conteneur && conteneur.querySelector('.pagination-wrapper');
    const filtres = document.querySelector('[data-filtres]');
    if (!pagination && !filtres) return;
    if (!estTelephone()) return;
    grille.dataset.pret = 'true';

    const etat = {
      grille,
      total: parseInt(grille.dataset.total, 10) || grille.children.length,
      suivant: pagination ? lienSuivant(pagination) : null,
      lienSecours: pagination ? lienSuivant(pagination) : null,
      enCours: false,
      filtre: '',
      annonce: filtres ? filtres.querySelector('[data-filtres-etat]') : null,
      bouton: document.createElement('button'),
    };

    etat.bouton.type = 'button';
    etat.bouton.className = 'button button--secondary voir-plus';
    etat.bouton.addEventListener('click', () => chargerPageSuivante(etat));
    if (pagination) {
      pagination.hidden = true;
      pagination.insertAdjacentElement('beforebegin', etat.bouton);
    } else {
      etat.bouton.hidden = true;
    }
    majBoutonVoirPlus(etat);

    if (filtres) {
      filtres.querySelectorAll('[data-filtre]').forEach((pastille) => {
        pastille.addEventListener('click', async () => {
          filtres.querySelectorAll('[data-filtre]').forEach((p) => {
            const actif = p === pastille;
            p.classList.toggle('is-actif', actif);
            p.setAttribute('aria-pressed', actif ? 'true' : 'false');
          });
          etat.filtre = pastille.dataset.filtre || '';
          // Un filtre porte sur tout le catalogue : on charge d'abord la suite.
          while (etat.filtre && etat.suivant) {
            const ok = await chargerPageSuivante(etat);
            if (!ok) break;
          }
          appliquerFiltre(etat);
          majBoutonVoirPlus(etat);
        });
      });
    }
  }

  /* Démarrage et changements de taille d'écran -------------------------- */
  function initTout(racine) {
    initRepliables(racine);
    initDetails(racine);
    initRayons(racine);
    initEquipes(racine);
    initBarresAchat(racine);
    initGrille();
  }

  function demarrer() {
    initTout(document);
    mq.addEventListener('change', () => {
      document.querySelectorAll('[data-repliable]').forEach(majRepliable);
      initDetails(document);
      initRayons(document);
      initEquipes(document);
      initGrille();
    });
    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-repliable]').forEach(majRepliable);
    });
    // Tri de la collection : Shopify remplace la grille, on la réinitialise.
    const conteneurGrille = document.getElementById('ProductGridContainer');
    if (conteneurGrille && 'MutationObserver' in window) {
      new MutationObserver(() => initGrille()).observe(conteneurGrille, { childList: true, subtree: false });
    }
    // Éditeur de thème : une section rechargée doit être réinitialisée.
    document.addEventListener('shopify:section:load', (e) => initTout(e.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
